import {
  Box,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import messages from '../messages';

function MissingOrInvalidFieldsDetails({ intl, fields, applicantNames }) {
  return (
    <Stack spacing={1} padding={2} paddingRight={6}>
      <Typography variant="titleSmall" fontWeight="bold">
        {intl.formatMessage(messages.missingRequiredFields)}
      </Typography>
      <Box
        sx={{
          paddingLeft: 1,
        }}
      >
        {fields.map((field) => (
          <Typography component="li" variant="bodySmall">
            {field}
          </Typography>
        ))}
      </Box>
      <Typography variant="titleSmall" fontWeight="bold">
        {intl.formatMessage(messages.applicantsWithMissingFields)}
      </Typography>
      <Box
        sx={{
          paddingLeft: 1,
        }}
      >
        {applicantNames.map((name) => (
          <Typography component="li" variant="bodySmall">
            {name}
          </Typography>
        ))}
      </Box>
    </Stack>
  );
}

export default MissingOrInvalidFieldsDetails;
